export default {
  label: '人力资源专员',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '人力资源专员是人力资源部门的基础性职位，主要负责日常的人力资源管理工作，包括招聘、培训、绩效考核、员工关系管理等',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '负责招聘工作，包括发布招聘信息、筛选简历、组织面试、办理入职手续等',
          id: '0-2-1',
        },
        {
          label: '负责员工培训计划的制定与实施，协助新员工培训',
          id: '0-2-2',
        },
        {
          label: '负责员工绩效考核的具体实施，协助部门负责人完成绩效管理工作',
          id: '0-2-3',
        },
        {
          label: '负责员工关系管理，处理员工离职、异动等事务',
          id: '0-2-4',
        },
        {
          label: '协助部门负责人完成企业文化建设、团队活动组织等工作',
          id: '0-2-5',
        }
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '具备本科及以上学历，人力资源管理、心理学或相关专业优先',
          id: '0-3-1',
        },
        {
          label: '熟悉劳动法及相关法律法规',
          id: '0-3-2',
        },
        {
          label: '具备良好的沟通协调能力和团队合作精神',
          id: '0-3-3',
        },
        {
          label: '熟练使用办公软件，如Excel、Word等',
          id: '0-3-4',
        }
      ],
    },
    {
      label: '薪资情况',
      id: '0-4',
      children: [
        {
          label: '8000-15000元',
          id: '0-4-1',
        },
      ],
    }
  ],
};